import { ConfigService } from '@shared/services/config.service';

export const Footer = () => {
  const isStaging = ConfigService.isStaging();
  
  return (
    <footer className={`${isStaging ? 'bg-blue-500/60' : 'bg-white/60'} backdrop-blur-md border border-white/20 rounded-2xl shadow-lg px-6 py-1`}>
      <div className="flex flex-col items-center text-center">
        <div className={`text-sm ${isStaging ? 'text-white' : 'text-gray-700'}`}>
          © 2025 Erlia Earth Data Lab.
        </div>
        <div className={`text-sm ${isStaging ? 'text-white' : 'text-gray-700'}`}>
          Versión {ConfigService.getAppVersion()}
          {isStaging ? ' (STG version)' : ''}
        </div>
      </div>
    </footer>
  );
}; 